// extracted by mini-css-extract-plugin
module.exports = {"container":"work-module--container--294Dy","img":"work-module--img--1Fgv_","text":"work-module--text--1DBjH"};